<template>
  <div class="fosoftech-brand">
    <!-- <div class="brand-content"> -->
       
      
      <!-- 品牌文字 -->
      <div class="brand-text-wrapper">
        <div class="brand-img">
          <img src="@/assets/dsj.png" alt="logo" class="brand-img-img">
        </div>
        <h1 class="brand-text">
          QHD BIG DATA
          <!-- <sup class="trademark">®</sup> -->
        </h1>
        <div class="loader">
          <div class="loader-square"></div>
          <div class="loader-square"></div>
          <div class="loader-square"></div>
          <div class="loader-square"></div>
          <div class="loader-square"></div>
          <!-- <div class="loader-square"></div> -->
        </div>
        

      
      </div>

    <!-- </div>、 -->
  </div>
</template>

<script>
export default {
  name: 'FosoftechBrand',
  data() {
    return {
      progress: 0, // 进度值
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1920
    }
  },
  mounted() {
    // 进度条动画
    this.animateProgress()
    
    // 监听窗口大小变化
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
      this.windowWidth = window.innerWidth
    }
  },
  beforeUnmount() {
    // 清理事件监听
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    // 获取分段数量
    getSegments() {
      const segmentCount = Math.ceil(this.progress / 5) // 每5%一个段
      return Array(Math.max(1, segmentCount)).fill(0)
    },
    // 进度条动画
    animateProgress() {
      const targetProgress = 100
      const duration = 3000 // 3秒完成
      const steps = 60
      const increment = targetProgress / steps
      const stepDuration = duration / steps
      let currentStep = 0
      
      const timer = setInterval(() => {
        currentStep++
        this.progress = Math.min(increment * currentStep, targetProgress)
        
        if (currentStep >= steps) {
          clearInterval(timer)
          // 完成后循环动画
          setTimeout(() => {
            this.progress = 0
            this.animateProgress()
          }, 1000)
        }
      }, stepDuration)
    }
  }
}
</script>

<style scoped>
.fosoftech-brand {
  width: 80%;
  background: #0e0d0d;
  padding:0 20px 60px 40px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.fosoftech-brand::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 30%, rgba(74, 121, 253, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 70% 70%, rgba(74, 121, 253, 0.03) 0%, transparent 50%);
  z-index: 0;
  pointer-events: none;
}

.brand-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  max-width: 800px;
  position: relative;
  z-index: 1;
}

.figure-icon {
  flex-shrink: 0;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.figure-gif {
  width: 80px;
  height: auto;
  animation: float 3s ease-in-out infinite;
  object-fit: contain;
}

.figure-svg {
  width: 60px;
  height: 80px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.brand-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.brand-text {
  font-size: 60px;
  font-weight: bolder;
  font-style: italic;
  color: #2149b6;
  margin: 0;
  letter-spacing: 2px;
  font-family: 'Arial', sans-serif;
  text-transform: uppercase;
  position: relative;
  text-shadow: 0 2px 8px rgba(63, 131, 219, 0.3);
}

.trademark {
  font-size: 38px;
  vertical-align: super;
  color: #121f44;
  font-weight: normal;
  margin-left: 4px;
  position: relative;
  top: -10px;
  transform: skewX(15deg);
  font-style: italic;
  text-transform: uppercase;
}

/* 进度条容器 */
.progress-bar-container {
  position: relative;
  width: 114%;
  height: 32px;
  margin-top: 10px;
}

/* 进度条轨道 - 平行四边形形状 */
.progress-track {
  position: relative;
  width: 100%;
  height: 100%;
  border: 2px solid #4A79FD;
  padding: 1.5px;
  background: rgba(74, 121, 253, 0.05);
  transform: skewX(-15deg);
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 
    0 0 15px rgba(74, 121, 253, 0.2),
    inset 0 0 10px rgba(74, 121, 253, 0.05);
  box-sizing: border-box;
}

/* 进度填充 */
.progress-fill {
  position: absolute;
  top: 1.5px;
  left: 1.5px;
  bottom: 1.5px;
  height: calc(100% - 3px);
  display: flex;
  align-items: stretch;
  transition: width 0.1s linear;
  overflow: hidden;
  transform: skewX(-10deg);
  transform-origin: left center;
}

/* 进度分段 */
.progress-segment {
  flex: 1;
  min-width: 20px;
  height: 100%;
  background: linear-gradient(135deg, #4A79FD 0%, #5B8AFF 50%, #4A79FD 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.5);
  margin-right: 2px;
  position: relative;
  box-shadow: 
    inset 0 0 10px rgba(0, 0, 0, 0.15),
    0 0 8px rgba(74, 121, 253, 0.3);
}

.progress-segment:last-child {
  border-right: none;
  margin-right: 0;
}

/* 分段内部高光 */
.progress-segment::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.3) 0%,
    transparent 50%,
    rgba(0, 0, 0, 0.1) 100%
  );
  pointer-events: none;
}

/* 进度百分比文字 */
.progress-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) skewX(15deg);
  font-size: 14px;
  font-weight: 600;
  color: #4A79FD;
  z-index: 10;
  white-space: nowrap;
  font-family: 'Arial', sans-serif;
  transition: left 0.1s linear;
  text-shadow: 0 1px 3px rgba(74, 121, 253, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .brand-text {
    font-size: 36px;
  }
  
  .figure-gif {
    width: 60px;
  }
  
  .figure-svg {
    width: 40px;
    height: 60px;
  }
  
  .progress-bar-container {
    height: 32px;
  }
  
  .progress-text {
    font-size: 10px;
    right: 8px;
  }
  
  .fosoftech-brand {
    padding: 30px 15px;
  }
}

@media (max-width: 480px) {
  .brand-text {
    font-size: 28px;
    letter-spacing: 1px;
  }
  
  .brand-content {
    gap: 15px;
  }
  
  .figure-gif {
    width: 50px;
  }
  
  .figure-svg {
    width: 35px;
    height: 50px;
  }
  
  .trademark {
    font-size: 14px;
  }
}
.brand-slogan {
  margin-top: 180px;
  text-align: center;
}

.slogan-text {
  font-size: 40px;
  color: #0c1429;
  font-weight: 500;
  letter-spacing: 1px;
  font-family: 'Arial', sans-serif;
  text-transform: uppercase;
  position: relative;
  display: inline-block;
  text-shadow: 0 2px 6px rgba(74, 121, 253, 0.2);
  transform: skewX(-15deg);
  transform-origin: left center;
}





/* From Uiverse.io by R5Program */ 
/* Container for loader */
.loader {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 60px;
}

/* Individual squares */
.loader-square {
  width: 22px;
  height: 22px;
  background-color: rgb(0, 247, 255);
  border-radius: 4px;
  box-shadow: 0 0 12px rgba(4, 136, 252, 0.8);
  animation: scaleBounce 1.2s infinite ease-in-out;
  position: relative;
}

/* Splash effect */
.loader-square::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 247, 255, 0.5);
  border-radius: 50%;
  opacity: 0;
  transform: scale(1);
  animation: splash 1.2s infinite ease-in-out;
}

/* Animations for each square */
.loader-square:nth-child(1) {
  animation-delay: -0.4s;
}
.loader-square:nth-child(2) {
  animation-delay: -0.2s;
}
.loader-square:nth-child(3) {
  animation-delay: 0s;
}
.loader-square:nth-child(4) {
  animation-delay: 0.2s;
}
.loader-square:nth-child(5) {
  animation-delay: 0.4s;
}
.loader-square:nth-child(6) {
  animation-delay: 0.6s;
}

@keyframes scaleBounce {
  0%,
  80%,
  100% {
    transform: scale(0.5);
    opacity: 0.6;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes splash {
  0% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 0;
    transform: scale(2.5);
  }
}
.brand-img {
  width: 100px;
  height: 100px;
  
}
.brand-img-img {
  width: 100%;
  height: 100%;
}
</style>
